const tagList = [
  {
    title: 'Careers',
    uri: '/tag/careers/',
  },
  {
    title: 'Entertainment',
    uri: '/tag/entertainment/',
  },
  {
    title: 'Venture Capital',
    uri: '/tag/venture-capital/',
  },
  {
    title: 'Coronavirus',
    uri: '/tag/coronavirus/',
  },
  {
    title: 'Autos',
    uri: '/tag/auto/',
  },
  {
    title: 'China',
    uri: '/tag/china/',
  },
  {
    title: 'Markets',
    uri: '/tag/markets/',
  },
  {
    title: 'The Travel Industry',
    uri: '/tag/travel-industry/',
  },
  {
    title: 'Energy',
    uri: '/tag/energy/',
  },
  {
    title: 'A.I.',
    uri: '/tag/artificial-intelligence/',
  },
  {
    title: 'Bitcoin',
    uri: '/tag/bitcoin/',
  },
  {
    title: 'Food and Drink',
    uri: '/tag/food-and-drink/',
  },
  {
    title: 'Sports',
    uri: '/tag/sports/',
  },
  {
    title: 'Luxury',
    uri: '/tag/luxury/',
  },
  {
    title: 'Politics',
    uri: '/tag/politics/',
  },
  {
    title: 'Economy',
    uri: '/tag/economy/',
  },
  {
    title: 'Cybersecurity',
    uri: '/tag/cybersecurity/',
  },
  {
    title: 'Real Estate',
    uri: '/tag/real-estate/',
  },
  {
    title: 'Russia',
    uri: '/tag/russia/',
  },
  {
    title: 'Startups',
    uri: '/tag/startups/',
  },
  {
    title: 'Diversity and Inclusion',
    uri: '/tag/diversity-and-inclusion/',
  },
  {
    title: 'Elections',
    uri: '/tag/elections/',
  },
  {
    title: 'Inflation',
    uri: '/tag/inflation/',
  },
  {
    title: 'Chief Executive Officer (CEO)',
    uri: '/tag/chief-executive-officer-ceo/',
  },
  {
    title: 'Investing',
    uri: '/tag/investing/',
  },
  {
    title: 'Earnings',
    uri: '/tag/earnings/',
  },
  {
    title: 'Social Media',
    uri: '/tag/social-media/',
  },
  {
    title: 'Taxes',
    uri: '/tag/taxes/',
  },
  {
    title: 'Climate Change',
    uri: '/tag/climate-change/',
  },
  {
    title: 'IPOs',
    uri: '/tag/initial-public-offerings/',
  },
  {
    title: 'Netflix',
    uri: '/tag/netflix/',
  },
  {
    title: 'Pharmaceutical Industry',
    uri: '/tag/pharmaceutical-industry/',
  },
  {
    title: 'Federal Reserve',
    uri: '/tag/federal-reserve/',
  },
  {
    title: 'Labor',
    uri: '/tag/labor/',
  },
  {
    title: 'Mergers and Acquisitions',
    uri: '/tag/mergers-and-acquisitions/',
  },
  {
    title: 'Electric Vehicles',
    uri: '/tag/electric-vehicles/',
  },
  {
    title: 'Private Equity',
    uri: '/tag/private-equity/',
  },
  {
    title: 'Congress',
    uri: '/tag/congress/',
  },
  {
    title: 'Housing',
    uri: '/tag/housing/',
  },
  {
    title: 'Unemployment',
    uri: '/tag/unemployment/',
  },
  {
    title: 'Remote Work',
    uri: '/tag/remote-work/',
  },
  {
    title: 'Banks',
    uri: '/tag/banks/',
  },
  {
    title: 'Interest Rates',
    uri: '/tag/interest-rates/',
  },
  {
    title: 'Mental Health',
    uri: '/tag/mental-health/',
  },
  {
    title: 'Layoffs',
    uri: '/tag/layoffs/',
  },
  {
    title: 'Human Resources',
    uri: '/tag/human-resources/',
  },
  {
    title: 'Student Loans and Debt',
    uri: '/tag/student-loans-and-debt/',
  },
  {
    title: 'Gen Z',
    uri: '/tag/gen-z/',
  },
  {
    title: 'Wealth',
    uri: '/tag/wealth/',
  },
  {
    title: 'Nutrition',
    uri: '/tag/nutrition/',
  },
];

export default tagList;
